<template>
  <v-container class="signUp mt-12">
    <v-row justify="center">
      <v-col md="6" sm="8" cols="11">
        <v-card class="pa-8 mt-12" flat color="#e8eddf" elevation="10">
          <div class="header text-center font-weight-light mb-8">Signup</div>
          <v-form @submit.prevent="submit">
            <v-text-field
              class="mt-3"
              v-model="email"
              name="email"
              color="#242423"
              outlined
              label="Email ID"
              append-icon="mdi-email"
            ></v-text-field>
            <v-text-field
              class="mt-3"
              v-model="password"
              name="password"
              color="#242423"
              outlined
              label="Password"
              :type="passwordShow ? 'text' : 'password'"
              :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="passwordShow = !passwordShow"
            ></v-text-field>
            <v-text-field
              class="mt-3"
              v-model="alias"
              name="alias"
              color="#242423"
              outlined
              label="Alias"
              append-icon="mdi-account-details"
            ></v-text-field>
            <p v-if="feedback" class="red--text text-center text--darken-4">* {{ feedback }}</p>
            <v-btn @click.prevent="submit" color="success" elevation="5" large>Submit</v-btn>
            <router-link style="text-decoration: none" :to="{ name: 'Login' }">
              <v-btn class="ml-2" color="info" elevation="5" large>Have an Account?</v-btn>
            </router-link>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from 'firebase'
import db from '../firebase'
import slugify from 'slugify'

export default {
  name: 'SignUp',

  data () {
    return {
      email: null,
      password: null,
      alias: null,
      feedback: null,
      slug: null,
      passwordShow: false
    }
  },

  methods: {
    submit () {
      if (this.alias && this.email && this.password) {
        this.feedback = null
        this.slug = slugify(this.alias, {
          replacement: '-',
          remove: /[!@#$%^&*()_+~.'"\-:]/g,
          lower: true
        })
        const ref = db.collection('users').doc(this.slug)
        ref.get().then(snapshot => {
          if (snapshot.exists) {
            this.feedback = 'This Alias is already taken'
          } else {
            firebase
              .auth()
              .createUserWithEmailAndPassword(this.email, this.password)
              .then(cred => {
                ref.set({
                  alias: this.alias,
                  geolocation: {
                    lat: null,
                    lng: null
                  },
                  user_id: cred.user.uid
                })
              })
              .then(() => {
                alert('Your account created Successfully! Kindly login twice to completely activate your accoune.')
                firebase
                  .auth()
                  .signOut()
                  .then(() => {
                    this.$router.push({ name: 'Login' })
                  })
              })
              .catch(err => {
                console.log(err)
                this.feedback = err.message
              })
          }
        })
      } else {
        this.feedback = 'Enter all fields'
      }
    }
  }
}
</script>

<style lang="scss">
.signUp .header {
  // font-family: "Bree Serif", serif;
  font-size: 4em;
  color: #242423;
}
</style>
